import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { ApolloLink, concat } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
// import { persistCache } from 'apollo-cache-persist'

export const Apollo = () => {
  // HTTP connection to the API
  const httpLink = createHttpLink({
    uri: `${process.env.REPORTS_KEYSTONE_URL}/admin/api`
  })

  const authLink = new ApolloLink((operation, forward) => {
    // Retrieve the authorization token from local storage.
    const token = localStorage.getItem('auth_token')

    // Use the setContext method to set the HTTP headers.
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })

    // Call the next link in the middleware chain.
    return forward(operation)
  })

  // Cache implementation
  const cache = new InMemoryCache()

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  // persistCache({
  //   cache,
  //   storage: window.localStorage
  // })
  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: concat(authLink, httpLink),
    cache
  })
  const reportsClient = new ApolloClient({
    link: createHttpLink({uri: `${process.env.REPORTS_KEYSTONE_URL}/admin/api`}),
    cache: new InMemoryCache()
  })
  const auditsClient = new ApolloClient({
    link: createHttpLink({uri: `${process.env.AUDITS_KEYSTONE_URL}/api/graphql`}),
    cache: new InMemoryCache()
  })

  const apolloProvider = new VueApollo({
    clients: {
      apolloClient,
      reportsClient,
      auditsClient
    },
    defaultClient: apolloClient
  })

  return apolloProvider
}



// WEBPACK FOOTER //
// ./src/lib/apollo.js